import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HubItemFacade } from './hub-item.facade';
import { setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class HubItemGuard {
  constructor(private hubItemFacade: HubItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const hubId = route.params.hubId || route.queryParams.hubId;

    this.hubItemFacade.setHubId(+hubId);
    return of(true);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.hubItemFacade);
  }
}
